import axios from 'axios';

const { location } = window;
const baseHost = location.host;
if (baseHost !== 'cosbrowser.cloud.tencent.com') {
  const redirectUrl = location.href.replace(baseHost, 'cosbrowser.cloud.tencent.com');
  if (location.href !== redirectUrl) location.href = redirectUrl;
}

const ins = axios.create({
  baseURL: `https://${baseHost}/`,
  timeout: 15000,
  validateStatus(status) {
    // 200 202 204 206返回给response 否则交给catch处理
    return Math.floor(status / 100) === 2; // 200 202 204 206
  },
});

// 添加响应拦截器
ins.interceptors.response.use(
  response => {
    const { data, status } = response;
    const statusSuccess = Math.floor(status / 100) === 2; // 200 202 204 206
    if (statusSuccess) {
      if (!data.code) {
        return data.data;
      }
      return Promise.reject(data);
    }
    return Promise.reject(data);
  },
  () => {
    const { lang } = window;
    const err = { code: -1, message: lang.t('error.networkError') };
    return Promise.reject(err);
  },
);

export default ins;
